import {
  PERSONAL_DETAILS_PATH,
  EDIT_PERSONAL_INFORMATION_PATH,
  EDIT_PASSWORD_PATH,
  ADD_PHONE_NUMBER_PATH,
  EDIT_HOME_ADDRESS_PATH,
  EDIT_MAILING_ADDRESS_PATH,
  EDIT_DELIVERY_ADDRESS_PATH
} from './routePaths';

export const routes = {
  [PERSONAL_DETAILS_PATH]: {
    path: PERSONAL_DETAILS_PATH,
    displayName: 'Personal Details',
    breadcrumbBackUrl: '/',
    description: 'View or Edit'
  },
  [EDIT_PERSONAL_INFORMATION_PATH]: {
    path: EDIT_PERSONAL_INFORMATION_PATH,
    displayName: 'Edit Personal Information',
    breadcrumbBackUrl: '/personal-details'
  },
  [EDIT_PASSWORD_PATH]: {
    path: EDIT_PASSWORD_PATH,
    displayName: 'Edit Password',
    breadcrumbBackUrl: '/personal-details'
  },
  [ADD_PHONE_NUMBER_PATH]: {
    path: ADD_PHONE_NUMBER_PATH,
    displayName: 'Edit Phone Number',
    breadcrumbBackUrl: '/personal-details'
  },
  [EDIT_HOME_ADDRESS_PATH]: {
    path: EDIT_HOME_ADDRESS_PATH,
    displayName: 'Edit Home Address',
    breadcrumbBackUrl: '/personal-details'
  },
  [EDIT_MAILING_ADDRESS_PATH]: {
    path: EDIT_MAILING_ADDRESS_PATH,
    displayName: 'Edit Mailing Address',
    breadcrumbBackUrl: '/personal-details'
  },
  [EDIT_DELIVERY_ADDRESS_PATH]: {
    path: EDIT_DELIVERY_ADDRESS_PATH,
    displayName: 'Edit Delivery Address',
    breadcrumbBackUrl: '/personal-details'
  }
};

export default routes;
